export const URL_API = (/development/gi).test(process.env.NODE_ENV) ?  'http://localhost/tokin/api/' : '/api/';